// Lifestyle Images Carousel
function initCdLifestyleSliders(scope) {
  var root = scope || document;
  var sliders = root.querySelectorAll('.cd-lifestyle-images__slider:not(.flickity-enabled)');
  if (typeof Flickity === 'undefined') return;

  sliders.forEach(function(sliderEl) {
    var options = JSON.parse(sliderEl.getAttribute('data-flickity-config'));
    var flkty = new Flickity(sliderEl, options);
    var wrapper = sliderEl.closest('.cd-lifestyle-images');
    if (!wrapper) return;

    var prevBtn = wrapper.querySelector('.button-prev');
    var nextBtn = wrapper.querySelector('.button-next');
    if (prevBtn) prevBtn.addEventListener('click', function() { flkty.previous(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { flkty.next(); });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initCdLifestyleSliders();
});

document.addEventListener('shopify:section:load', function(evt) {
  initCdLifestyleSliders(evt.target);
});

// Move Product Page Sections into Tabs
function moveContentToTabs(sourceElement, targetElementTab, targetElementAccordion) {
  // Get the content from the source element
  let contentToMove = sourceElement.innerHTML;
  // Set the content of the target element
  targetElementTab.innerHTML = contentToMove;
  targetElementAccordion.innerHTML = contentToMove;
  // Clear the source element
  sourceElement.innerHTML = '';
  sourceElement.remove();
}

// Variant Attribute Table
var sourceElement = document.getElementById('compare-specs');
var targetElementTab = document.getElementById('tab1');
var targetElementAccordion = document.getElementById('accordion1');
if (sourceElement) moveContentToTabs(sourceElement,targetElementTab,targetElementAccordion);

// Description Modal Demo
document.addEventListener('DOMContentLoaded', function() {
  const yourLink = document.querySelector('.description-modal-demo');
  const targetButton = document.querySelector('[class*="ai-product-metafield-trigger-"]');
  
  if (yourLink && targetButton) {
    yourLink.addEventListener('click', function(e) {
      e.preventDefault(); // Prevent default link behavior
      targetButton.click(); // Trigger click on the target button
    });
  }
});

// Expand First Accordion
document.addEventListener('DOMContentLoaded', function() {
  const firstAccordion = document.querySelector('.product_accordion__block .product_accordion__heading');
  if (firstAccordion) {
      firstAccordion.click();
  }
});

// Summary to Full Description
document.addEventListener('DOMContentLoaded', function() {
  const readMoreLinks = document.querySelectorAll('.read-more-link');
  
  readMoreLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get the target from href attribute
      const targetHref = this.getAttribute('href'); // #tab1 or #tab2
      const dataTab = this.getAttribute('data-tab'); // description, specifications, etc.
      
      // Check if we're on mobile (accordion) or desktop (tabs)
      const tabsContainer = document.querySelector('.tabing');
      const accordionContainer = document.querySelector('.product_description_accrordion');
      
      // Check which is currently visible
      const isTabsVisible = tabsContainer && window.getComputedStyle(tabsContainer).display !== 'none';
      const isAccordionVisible = accordionContainer && window.getComputedStyle(accordionContainer).display !== 'none';
      
      if (isTabsVisible) {
        // Handle tabs (desktop)
        handleTabNavigation(targetHref);
      } else if (isAccordionVisible) {
        // Handle accordion (mobile)
        handleAccordionNavigation(targetHref, dataTab);
      }
    });
  });
  
  function handleTabNavigation(targetHref) {
    const targetTab = document.querySelector(`a[href="${targetHref}"][data-toggle="tab"]`);
    
    if (targetTab) {
      targetTab.click();
      
      setTimeout(() => {
        document.querySelector('.tabing').scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);
    }
  }
  
  function handleAccordionNavigation(targetHref, dataTab) {
    // Map href to accordion heading text
    let targetHeadingText = '';
    
    if (targetHref === '#tab1') {
      targetHeadingText = 'Size & Specifications';
    } else if (targetHref === '#tab2') {
      targetHeadingText = 'Description';
    }
    
    // Find the corresponding accordion block
    const accordionBlocks = document.querySelectorAll('.product_accordion__block');
    let targetBlock = null;
    
    accordionBlocks.forEach(block => {
      const heading = block.querySelector('.product_accordion__heading');
      if (heading && heading.textContent.trim() === targetHeadingText) {
        targetBlock = block;
      }
    });
    
    if (targetBlock) {
      const heading = targetBlock.querySelector('.product_accordion__heading');
      const content = targetBlock.querySelector('.product_accordion__content');
      
      // Open the accordion if it's closed
      if (content && content.style.height === '0px') {
        // Trigger the accordion open (click on heading)
        heading.click();
      }
      
      // Scroll to the accordion after opening
      setTimeout(() => {
        targetBlock.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);
    }
  }
});

// Show rating snippet only if Reviews.io populates it
document.addEventListener('DOMContentLoaded', function() {
  const ratingSnippet = document.querySelector('.ruk_rating_snippet');
  
  if (!ratingSnippet) return;
  
  // Function to check if snippet has content
  function checkAndShowIfPopulated() {
    const content = ratingSnippet.innerHTML.trim();
    const hasContent = content !== '' && !content.match(/^\s*$/);
    
    if (hasContent) {
      ratingSnippet.style.display = 'block';
      return true;
    }
    return false;
  }
  
  // Use MutationObserver to watch for content changes
  const observer = new MutationObserver(function(mutations) {
    // Check if content was added and show if populated
    if (checkAndShowIfPopulated()) {
      observer.disconnect();
    }
  });
  
  // Start observing the snippet for changes
  observer.observe(ratingSnippet, {
    childList: true,
    subtree: true
  });
  
  // Fallback timeout - check one final time after 3 seconds
  setTimeout(function() {
    checkAndShowIfPopulated();
    observer.disconnect();
  }, 3000);
});

// hide if no features
document.addEventListener('DOMContentLoaded', function() {
  const featureItems = document.querySelectorAll('.cd_custom_product_features_block--item');
  let hiddenItems = 0;
  
  featureItems.forEach(item => {
    const ul = item.querySelector('ul');
    
    if (ul) {
      const listItems = ul.querySelectorAll('li');
      
      if (listItems.length === 0) {
        item.style.display = 'none';
        hiddenItems++;
      }
    }
  });
  
  // If any items were hidden, add margin-top to the quantity block
  if (hiddenItems > 0) {
    const quantityBlock = document.querySelector('.form_bg_row.quantity_block');
    if (quantityBlock) {
      quantityBlock.style.marginTop = '24px'; // Adjust the value as needed
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.back_in_stock_row').forEach(function(row) {
    var btn = row.querySelector('.back_in_stock_btn');
    var emailInput = row.querySelector('input[type="email"]');
    var responseEl = row.querySelector('.back_in_stock_response');

    if (!btn || !emailInput || !responseEl) return;

    btn.addEventListener('click', function(e) {
      e.preventDefault();

      var email = emailInput.value.trim();

      if (!email || !emailInput.validity.valid) {
        responseEl.innerHTML = '<div class="form-message form-message--error">Please enter a valid email address.</div>';
        responseEl.classList.add('active');
        responseEl.classList.remove('success_response');
        return;
      }

      var section = row.closest('[data-section-id]');
      var variantInput = section && section.querySelector('[name="id"]');
      var variantId = variantInput && variantInput.value;

      if (!variantId) return;

      btn.disabled = true;

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=XytiMz', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + variantId
                }
              }
            }
          }
        })
      })
      .then(function(res) {
        btn.disabled = false;
        if (res.ok) {
          var msgEl = document.createElement('div');
          msgEl.className = 'form-message form-message--success';
          msgEl.textContent = row.dataset.successMessage || "Thanks! We'll notify you when this item is back in stock.";
          responseEl.innerHTML = '';
          responseEl.appendChild(msgEl);
          responseEl.classList.add('active', 'success_response');
          emailInput.value = '';
        } else {
          return res.json().then(function(data) { throw data; });
        }
      })
      .catch(function(err) {
        btn.disabled = false;
        responseEl.innerHTML = '<div class="form-message form-message--error">Something went wrong. Please try again.</div>';
        responseEl.classList.add('active');
        responseEl.classList.remove('success_response');
        console.error('Klaviyo BIS error:', err);
      });
    });
  });
});

// Product features shimmer
document.addEventListener('DOMContentLoaded', function() {
  const featureItems = document.querySelectorAll('.cd_custom_product_features_block--item li');
  
  featureItems.forEach(item => {
    item.addEventListener('click', function() {
      // Add the clicked class to trigger shimmer
      this.classList.add('clicked');
      
      // Remove the class after animation completes
      setTimeout(() => {
        this.classList.remove('clicked');
      }, 600);
    });
  });
});

// Compatible products sheet — show after ATC, then open cart drawer
(function () {
  var pendingCartAdds = [];
  var skipCompatibleSheet = false;
  var sheetOpen = false;
  var suppressDrawerOpen = false;
  var onSheetClose = null;
  var sheetItems = [];
  var quantities = {};
  var cartInstanceRef = null;
  var previouslyFocused = null;

  window.CupsDirectCompatible = {
    skipNextSheet: function () {
      skipCompatibleSheet = true;
    },
    notifyProductAdded: function () {
      if (cartInstanceRef && typeof cartInstanceRef._onProductAdded === 'function') {
        skipCompatibleSheet = true;
        cartInstanceRef._onProductAdded();
        return;
      }
      if (window.theme && theme.Cart && typeof theme.Cart.prototype._onProductAdded === 'function') {
        skipCompatibleSheet = true;
        theme.Cart.prototype._onProductAdded.call(cartInstanceRef || theme.Cart.prototype);
      }
    }
  };

  function parseCartAddBody(body) {
    if (!body) return null;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return {
        id: body.get('id'),
        quantity: body.get('quantity') || 1
      };
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return {
        id: body.get('id'),
        quantity: body.get('quantity') || 1
      };
    }
    if (typeof body === 'string') {
      try {
        var json = JSON.parse(body);
        if (json.id) {
          return { id: json.id, quantity: json.quantity || 1 };
        }
        if (json.items && json.items[0] && json.items[0].id) {
          return {
            id: json.items[0].id,
            quantity: json.items[0].quantity || 1
          };
        }
      } catch (e) {
        var idMatch = body.match(/(?:^|&)id=(\d+)/);
        var qtyMatch = body.match(/(?:^|&)quantity=(\d+)/);
        if (idMatch) {
          return {
            id: idMatch[1],
            quantity: qtyMatch ? qtyMatch[1] : 1
          };
        }
      }
    }
    return null;
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (url && String(url).indexOf('/cart/add') !== -1) {
      var body = init && init.body;
      if (body == null && input && typeof Request !== 'undefined' && input instanceof Request) {
        // Request bodies are locked once read; only init.body carries parseable data here.
        body = null;
      }

      var parsed = parseCartAddBody(body);
      pendingCartAdds.push(
        parsed && parsed.id
          ? {
              id: String(parsed.id),
              qty: Math.max(1, parseInt(parsed.quantity, 10) || 1)
            }
          : null
      );
    }
    return originalFetch.apply(this, arguments);
  };

  function getCompatibleMap() {
    var el = document.getElementById('cd-compatible-map');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent.trim() || '{}');
    } catch (e) {
      return {};
    }
  }

  function getCompatibleEntry(variantId) {
    if (!variantId) return null;
    var entry = getCompatibleMap()[String(variantId)];
    if (!entry) return null;

    // Back-compat if map is still a bare array
    if (Array.isArray(entry)) {
      return { label: 'your selection', image: null, casePack: null, items: entry };
    }

    return {
      label: entry.label || 'your selection',
      image: entry.image || null,
      casePack: entry.casePack != null ? entry.casePack : null,
      items: entry.items || []
    };
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney && theme.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function itemLabel(item) {
    if (!item.title || item.title === 'Default Title') return item.productTitle;
    return item.productTitle + ' — ' + item.title;
  }

  function getQty(variantId) {
    var key = String(variantId);
    var qty = parseInt(quantities[key], 10);
    return qty > 0 ? qty : 0;
  }

  function setQty(variantId, qty) {
    var key = String(variantId);
    var next = Math.max(0, parseInt(qty, 10) || 0);
    quantities[key] = next;

    var input = document.querySelector('[data-cd-compatible-qty="' + key + '"]');
    if (input && String(input.value) !== String(next)) {
      input.value = next;
    }

    var card = document.querySelector('.cd-compatible-sheet__card[data-variant-id="' + key + '"]');
    if (card) {
      card.classList.toggle('has-qty', next > 0);
    }

    updateSelectedUI();
  }

  function getSelectedItems() {
    return sheetItems.filter(function (item) {
      return getQty(item.id) > 0;
    });
  }

  function getSelectedUnitCount() {
    return getSelectedItems().reduce(function (sum, item) {
      return sum + getQty(item.id);
    }, 0);
  }

  function priceHtml(item) {
    var onSale = item.compareAtPrice && item.compareAtPrice > item.price;
    if (onSale) {
      return (
        '<div class="price price--listing price--on-sale">' +
          '<div class="price__regular">' +
            '<span class="visually-hidden">Regular price</span>' +
            '<span class="price-item price-item--regular">' + formatMoney(item.price) + '</span>' +
          '</div>' +
          '<div class="price__sale">' +
            '<span class="visually-hidden">Sale price</span>' +
            '<span class="price-item price-item--sale">' + formatMoney(item.price) + '</span>' +
            '<div class="price__compare">' +
              '<span class="visually-hidden">Regular price</span>' +
              '<s class="price-item price-item--regular">' + formatMoney(item.compareAtPrice) + '</s>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }

    return (
      '<div class="price price--listing">' +
        '<div class="price__regular">' +
          '<span class="visually-hidden">Regular price</span>' +
          '<span class="price-item price-item--regular">' + formatMoney(item.price) + '</span>' +
        '</div>' +
      '</div>'
    );
  }

  function updateSelectedUI() {
    var selected = getSelectedItems();
    var selectedEl = document.querySelector('[data-cd-compatible-selected]');
    var addBtn = document.querySelector('[data-cd-compatible-add-selected]');
    if (!selectedEl || !addBtn) return;

    if (!selected.length) {
      selectedEl.innerHTML = '<p class="cd-compatible-sheet__selected-empty">No selection made yet.</p>';
    } else {
      selectedEl.innerHTML = selected.map(function (item) {
        var qty = getQty(item.id);
        var meta =
          item.casePack != null && item.casePack !== ''
            ? escapeHtml(item.casePack) + ' x ' + escapeHtml(qty)
            : escapeHtml(qty);
        return (
          '<div class="cd-compatible-sheet__selected-row" data-variant-id="' + escapeHtml(item.id) + '">' +
            '<span class="cd-compatible-sheet__selected-name">' + escapeHtml(itemLabel(item)) + '</span>' +
            '<span class="cd-compatible-sheet__selected-meta">' + meta + '</span>' +
          '</div>'
        );
      }).join('');
    }

    var count = getSelectedUnitCount();
    addBtn.textContent = 'Add ' + count + ' to basket';
    addBtn.disabled = count === 0;
  }

  function renderGrid(items) {
    var list = document.querySelector('[data-cd-compatible-list]');
    if (!list) return;

    list.innerHTML = items.map(function (item) {
      var id = escapeHtml(item.id);
      var qty = getQty(item.id);
      var disabledClass = item.available === false ? ' is-disabled' : '';
      var imageHtml = item.image
        ? '<img class="product-card__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(itemLabel(item)) + '" width="240" height="240" loading="lazy">'
        : '';
      var summaryHtml = item.summary
        ? '<div class="product-item__summary rte">' + escapeHtml(item.summary) + '</div>'
        : '';
      var casePackHtml = item.casePack
        ? '<p class="cd-compatible-sheet__case-pack">Case Pack: ' + escapeHtml(item.casePack) + '</p>'
        : '';

      return (
        '<div class="product-item-block view-mode-grid cd-compatible-sheet__card-wrap">' +
          '<div class="product-card product-card-wrapper cd-compatible-sheet__card' + (qty > 0 ? ' has-qty' : '') + disabledClass + '"' +
            ' data-variant-id="' + id + '">' +
            '<div class="product-item--media">' +
              '<div class="product-card__image-with-placeholder-wrapper">' +
                '<div class="product-card__image-wrapper">' + imageHtml + '</div>' +
              '</div>' +
            '</div>' +
            '<div class="product-item--info">' +
              '<h5 class="item__title product-card__title">' + escapeHtml(itemLabel(item)) + '</h5>' +
              casePackHtml +
              summaryHtml +
              '<div class="product-item__price_and_reviews_row">' + priceHtml(item) + '</div>' +
              '<div class="qty cd-compatible-sheet__qty" data-cd-compatible-qty-wrap="' + id + '">' +
                '<button type="button" class="minus_btn qty_btn" data-cd-compatible-qty-minus="' + id + '" aria-label="Decrease quantity"></button>' +
                '<input type="number" value="' + qty + '" min="0" inputmode="numeric" pattern="[0-9]*"' +
                  ' class="product-form__input product-form__input--quantity"' +
                  ' data-cd-compatible-qty="' + id + '" aria-label="Quantity">' +
                '<button type="button" class="plus_btn qty_btn" data-cd-compatible-qty-plus="' + id + '" aria-label="Increase quantity"></button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');
  }

  function renderAddedProduct(entry) {
    var block = document.querySelector('[data-cd-compatible-added]');
    if (!block) return;

    var titleEl = block.querySelector('[data-cd-compatible-added-title]');
    var caseEl = block.querySelector('[data-cd-compatible-added-case]');
    var imageEl = block.querySelector('[data-cd-compatible-added-image]');

    if (titleEl) {
      titleEl.textContent = entry.label || 'your selection';
    }

    if (caseEl) {
      var qty = entry.qty || 1;
      if (entry.casePack != null && entry.casePack !== '') {
        caseEl.textContent = 'Case Pack: ' + entry.casePack + ' × ' + qty;
        caseEl.hidden = false;
      } else {
        caseEl.textContent = 'Qty: ' + qty;
        caseEl.hidden = false;
      }
    }

    if (imageEl) {
      if (entry.image) {
        imageEl.innerHTML =
          '<img src="' + escapeHtml(entry.image) + '" alt="" width="64" height="64" loading="lazy">';
      } else {
        imageEl.innerHTML = '';
      }
    }

    block.hidden = false;
  }

  function bindFocusTrap(panel, elementToFocus) {
    if (!window.slate || !slate.a11y || typeof slate.a11y.trapFocus !== 'function' || !panel) return;
    slate.a11y.trapFocus({ container: panel, elementToFocus: elementToFocus || panel });
  }

  function unbindFocusTrap(panel) {
    if (!window.slate || !slate.a11y || typeof slate.a11y.removeTrapFocus !== 'function') return;
    slate.a11y.removeTrapFocus({ container: panel });
  }

  function openSheet(entry, closeCallback) {
    var sheet = document.getElementById('cd-compatible-sheet');
    if (!sheet) {
      if (closeCallback) closeCallback();
      return;
    }

    sheetItems = (entry.items || []).filter(function (item) {
      return item && item.available !== false;
    }).slice(0, 4);

    quantities = {};
    sheetItems.forEach(function (item) {
      quantities[String(item.id)] = 0;
    });
    onSheetClose = closeCallback;
    previouslyFocused = document.activeElement;

    var intro = sheet.querySelector('[data-cd-compatible-intro]');
    if (intro) {
      var label = entry.label || 'your selection';
      intro.innerHTML =
        'Good news, we’ve found some products that fit <strong class="cd-compatible-sheet__intro-name">' +
        escapeHtml(label) +
        '</strong>.';
    }

    renderAddedProduct(entry);
    renderGrid(sheetItems);
    updateSelectedUI();

    sheetOpen = true;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-compatible-sheet-open', 'show_overlay');

    var panel = sheet.querySelector('.cd-compatible-sheet__panel');
    var skipBtn = sheet.querySelector('[data-cd-compatible-skip]');
    bindFocusTrap(panel, skipBtn);
  }

  function closeSheet() {
    var sheet = document.getElementById('cd-compatible-sheet');
    if (!sheet || !sheetOpen) return;

    sheetOpen = false;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cd-compatible-sheet-open', 'show_overlay');
    sheetItems = [];
    quantities = {};
    unbindFocusTrap(sheet.querySelector('.cd-compatible-sheet__panel'));

    var focusTarget = previouslyFocused;
    previouslyFocused = null;
    if (focusTarget && typeof focusTarget.focus === 'function') {
      try {
        focusTarget.focus();
      } catch (e) {}
    }

    var cb = onSheetClose;
    onSheetClose = null;
    if (cb) cb();
  }

  function rerenderCart() {
    if (cartInstanceRef && typeof cartInstanceRef._rerenderCart === 'function') {
      return cartInstanceRef._rerenderCart() || Promise.resolve();
    }

    if (!window.theme || !theme.Cart || !theme.Cart.prototype._rerenderCart) return Promise.resolve();

    var drawer = document.querySelector('#sidebar-cart');
    if (!drawer) return Promise.resolve();

    var options;
    try {
      options = JSON.parse(drawer.getAttribute('data-section-settings'));
    } catch (e) {
      return Promise.resolve();
    }

    if (!options || typeof options !== 'object') return Promise.resolve();

    return theme.Cart.prototype._rerenderCart.call({ options: options, container: drawer }) || Promise.resolve();
  }

  function addSelectedToBasket() {
    var selected = getSelectedItems();
    var addBtn = document.querySelector('[data-cd-compatible-add-selected]');
    if (!selected.length || !addBtn || addBtn.disabled) return;

    var originalText = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    var payload = {
      items: selected.map(function (item) {
        return { id: Number(item.id), quantity: getQty(item.id) };
      })
    };

    originalFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok || result.json.status === 422) {
          addBtn.textContent = 'Error — try again';
          setTimeout(function () {
            updateSelectedUI();
          }, 1500);
          return;
        }

        return Promise.resolve(rerenderCart()).then(function () {
          closeSheet();
        });
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = originalText;
      });
  }

  function bindSheetEvents() {
    var sheet = document.getElementById('cd-compatible-sheet');
    if (!sheet) return;

    sheet.addEventListener('click', function (e) {
      if (e.target === sheet) {
        e.preventDefault();
        e.stopPropagation();
        closeSheet();
        return;
      }

      if (e.target.closest('[data-cd-compatible-skip]')) {
        e.preventDefault();
        e.stopPropagation();
        closeSheet();
        return;
      }

      if (e.target.closest('[data-cd-compatible-add-selected]')) {
        e.preventDefault();
        addSelectedToBasket();
        return;
      }

      var clearBtn = e.target.closest('[data-cd-compatible-clear]');
      if (clearBtn) {
        e.preventDefault();
        setQty(clearBtn.getAttribute('data-cd-compatible-clear'), 0);
        return;
      }

      var minusBtn = e.target.closest('[data-cd-compatible-qty-minus]');
      if (minusBtn) {
        e.preventDefault();
        var minusId = minusBtn.getAttribute('data-cd-compatible-qty-minus');
        setQty(minusId, getQty(minusId) - 1);
        return;
      }

      var plusBtn = e.target.closest('[data-cd-compatible-qty-plus]');
      if (plusBtn) {
        e.preventDefault();
        var plusId = plusBtn.getAttribute('data-cd-compatible-qty-plus');
        setQty(plusId, getQty(plusId) + 1);
      }
    });

    sheet.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cd-compatible-qty]');
      if (!input) return;
      setQty(input.getAttribute('data-cd-compatible-qty'), input.value);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheetOpen) {
        e.preventDefault();
        closeSheet();
      }
    });
  }

  function initCompatibleSheet() {
    if (
      !window.theme ||
      !theme.Cart ||
      !theme.Cart.prototype ||
      typeof theme.Cart.prototype._onProductAdded !== 'function' ||
      typeof theme.Cart.prototype._sidebarDrawerOpen !== 'function'
    ) {
      console.warn(
        'CupsDirect: compatible-products sheet disabled — theme.Cart.prototype._onProductAdded/_sidebarDrawerOpen ' +
        'not found. The base theme\'s Cart implementation may have changed.'
      );
      return;
    }

    bindSheetEvents();

    var originalOnProductAdded = theme.Cart.prototype._onProductAdded;
    var originalSidebarOpen = theme.Cart.prototype._sidebarDrawerOpen;
    var originalRerenderCart = theme.Cart.prototype._rerenderCart;

    if (typeof originalRerenderCart === 'function') {
      theme.Cart.prototype._rerenderCart = function () {
        if (this && this.container) {
          cartInstanceRef = this;
        }
        return originalRerenderCart.apply(this, arguments);
      };
    }

    theme.Cart.prototype._sidebarDrawerOpen = function () {
      if (suppressDrawerOpen) return;
      if (this && this.container) {
        cartInstanceRef = this;
      }
      return originalSidebarOpen.apply(this, arguments);
    };

    theme.Cart.prototype._onProductAdded = function () {
      if (this && this.container) {
        cartInstanceRef = this;
      }

      var cartCtx = cartInstanceRef || this;
      var added = pendingCartAdds.shift() || null;

      if (skipCompatibleSheet) {
        skipCompatibleSheet = false;
        return originalOnProductAdded.call(cartCtx);
      }

      var entry = added ? getCompatibleEntry(added.id) : null;
      var items = entry
        ? (entry.items || []).filter(function (item) {
            return item && item.available !== false;
          })
        : [];

      if (!items.length) {
        return originalOnProductAdded.call(cartCtx);
      }

      suppressDrawerOpen = true;
      originalOnProductAdded.call(cartCtx);

      openSheet(
        {
          label: entry.label,
          image: entry.image,
          casePack: entry.casePack,
          qty: added.qty,
          items: items
        },
        function () {
          suppressDrawerOpen = false;
          setTimeout(function () {
            originalSidebarOpen.call(cartCtx || cartInstanceRef || theme.Cart.prototype);
          }, 50);
        }
      );
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompatibleSheet);
  } else {
    initCompatibleSheet();
  }
})();
